import React from 'react';
import {withStyles} from "@material-ui/styles";
import {
    exportReport
} from "../../util/ApiUtils";
import {NotificationManager, NotificationContainer} from "react-notifications";
import {Spinner} from "../common/Spinner";
import {
    addApprovedContractorsRevision,
    approvedContractors,
    approvedContractorsRevision,
    deleteApprovedContractors,
    saveOrUpdateApprovedContractors
} from "../../util/ApprovedContractorsApiUtils";
import {BlueButton, GreenButton, GreyButton, OrangeButton, RedButton} from "../common/ButtonsConstants";
import {AddCircleOutlineTwoTone, AddCircleTwoTone, SystemUpdateAltTwoTone} from "@material-ui/icons";
import moment from "moment";
import CardHeader from "@material-ui/core/CardHeader";
import Modal from "@material-ui/core/Modal";
import CommonRevisionModal from "../common/CommonRevisionModal";
import CardContent from "@material-ui/core/CardContent";
import TableComponent from "../common/TableComponent";
import TextField from "@material-ui/core/TextField";
import InputLabel from "@material-ui/core/InputLabel";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import {KeyboardDatePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import SignaturePad from "react-signature-canvas";
import {expiredDateStyle} from "../../util/CommonUtils";
import {deleteFile, uploadMultipleFiles} from "../../util/OperationModuleApiUtils";
import {Table, TableHead} from "@material-ui/core";
import TableBody from "@material-ui/core/TableBody";
import * as ApiUtils from "../../util/ApiUtils";
import Dropzone from "react-dropzone";
import * as CommonUtils from "../../util/CommonUtils";
import { t } from '../../i18n';

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
}));

const columns = [
    {
        name: t('operation.approvedContractors.identifier'),
        id: 'identifier',
        type: "text",
    },
    {
        name: t('operation.approvedContractors.nameOfSubcontractor'),
        id: 'name',
        type: "text",
        cellStyle: {
            width: '15%'
        }
    },
    {
        name: t('operation.approvedContractors.assessedDate'),
        id: 'assessedDateDisplay',
        type: "text",
        cellStyle: {
            width: '15%'
        }
    },
    {
        name: t('operation.approvedContractors.assessorName'),
        id: 'assessor',
        type: "text",
        cellStyle: {
            width: '15%'
        }
    },
    {
        name: t('operation.approvedContractors.agreementExpiryDate'),
        id: 'agreementExpiryDateDisplay',
        type: "text",
        cellStyle: (cellData) => {
            return {
                width: '15%',
                ...expiredDateStyle(cellData.value)
            }
        }
    },
    {
        name: t('operation.approvedContractors.insuranceExpiryDate'),
        id: 'insuranceExpiryDateDisplay',
        type: "text",
        cellStyle: (cellData) => {
            return {
                width: '15%',
                ...expiredDateStyle(cellData.value)
            }
        }
    },
    {
        name: t('operation.approvedContractors.authorisingPerson'),
        id: 'authorisingPerson',
        type: "text",
        cellStyle: {
            width: '15%'
        }
    },
];

class ApprovedContractor extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            approvedContractors: [],
            latestRevision: {},
            isLoading: true,
            isEditing: false,
            id: null,
            show: false,
            identifier: "",
            name: "",
            assessedDate: null,
            assessor: "",
            copyOfAgreement: "",
            agreementExpiryDate: null,
            copiesOfInsurance: "",
            insuranceExpiryDate: null,
            safeWorkMethod: "",
            authorisedDate: null,
            authorisingPerson: "",
            signature: "",
            selectedFiles: [],
        };
        this.loadApprovedContractors = this.loadApprovedContractors.bind(this);
        this.loadApprovedContractorsRevision = this.loadApprovedContractorsRevision.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.onSave = this.onSave.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.handleTextChange = this.handleTextChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onDelete = this.onDelete.bind(this);
        this.onEdit = this.onEdit.bind(this);
        this.addRevision = this.addRevision.bind(this);
        this.onSignatureEnd = this.onSignatureEnd.bind(this);
        this.deleteFileFromRecord = this.deleteFileFromRecord.bind(this);
        this.onDrop = this.onDrop.bind(this);
    }

    sigPad = {};

    clear = () => {
        this.sigPad.clear()
    };

    onDrop(files) {
        let selectedFiles = this.state.selectedFiles;
        files.map(file => selectedFiles.push(file));
        this.setState({
            selectedFiles: selectedFiles
        });
    }

    deleteFileFromRecord(fileId) {
        console.log("this.state.id", this.state.id);
        console.log("fileId", fileId);
        deleteFile("/approved-contractors/deleteFile", this.state.id, fileId)
            .then(() => {
                const remainingFiles = this.state.files.filter(function(file) {
                    return file.id !== fileId;
                });
                this.setState({
                    files: remainingFiles,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    showModal() {
        this.setState({
            show: true
        });
    }

    closeModal(updatedRevision) {
        console.log("updatedRevision");
        console.log(updatedRevision);
        if (updatedRevision) {
            this.setState({
                show: false,
                latestRevision: updatedRevision,
            });
        } else {
            this.setState({
                show: false,
            });
        }
    }

    componentDidMount() {
        this.loadApprovedContractors();
        this.loadApprovedContractorsRevision();
    }

    addRevision(request) {
        addApprovedContractorsRevision(request)
            .then(response => {
                NotificationManager.success(t('app.notifications.success'), t('messages.revisionUpdated'), 5000);
                console.log('response');
                console.log(response);
                this.closeModal(response);
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }

    loadApprovedContractorsRevision() {
        approvedContractorsRevision()
            .then(response => {
                console.log('approvedContractors revision', response);
                this.setState({
                    latestRevision: response,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    loadApprovedContractors() {
        approvedContractors()
            .then(response => {
                console.log('approvedContractorsResponse', response);
                this.setState({
                    approvedContractors: response,
                    isLoading: false,
                });
            })
            .catch(error => {
                console.log(error);
            });
    }

    onEdit(row) {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: false,
            id: row.id,
            header: `${row.identifier}`,
            name: row.name,
            assessedDate: row.assessedDate,
            assessor: row.assessor,
            copyOfAgreement: row.copyOfAgreement,
            agreementExpiryDate: row.agreementExpiryDate,
            copiesOfInsurance: row.copiesOfInsurance,
            insuranceExpiryDate: row.insuranceExpiryDate,
            safeWorkMethod: row.safeWorkMethod,
            authorisingPerson: row.authorisingPerson,
            authorisedDate: row.authorisedDate,
            signature: row.signature,
            files: row.files,
        });
    }

    handleAddRow() {
        this.setState({
            isEditing: true,
            isLoading: false,
            isNew: true,
            id: null,
            date: null,
            showTime: null,
            identifier: "",
            name: "",
            assessedDate: null,
            assessor: "",
            copyOfAgreement: "",
            agreementExpiryDate: null,
            copiesOfInsurance: "",
            insuranceExpiryDate: null,
            safeWorkMethod: "",
            authorisingPerson: "",
            authorisedDate: null,
            signature: "",
            header: t('common.newRecord'),
        })
    }

    reset() {
        this.setState({
            isEditing: false,
            isLoading: true,
            isNew: true,
            id: null,
            date: null,
            showTime: null,
            identifier: "",
            name: "",
            assessedDate: null,
            assessor: "",
            copyOfAgreement: "",
            agreementExpiryDate: null,
            copiesOfInsurance: "",
            insuranceExpiryDate: null,
            safeWorkMethod: "",
            authorisingPerson: "",
            authorisedDate: null,
            signature: "",
            header: t('common.newRecord'),
            files: [],
            selectedFiles: [],
        });
        this.loadApprovedContractors();
    }

    onCancel() {
        this.reset();
    }

    onDelete(record) {
        console.log(record);
        deleteApprovedContractors(record)
            .then(() => {
                console.log("removed id " + record.id);
                console.log("removed " + record);
                console.log(this.state);
                NotificationManager.success(t('app.notifications.success'), t('messages.approvedContractorRemoved'), 5000);
                this.reset();
            }).catch(error => {
            console.log("error");
            console.log(error);
            NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
        });
    }


    onSave(event) {
        event.preventDefault();
        this.setState({
                trimmedDataURL: this.sigPad.toDataURL('image/png'),
            },
            () => {
                console.log("state after updating", this.state);
                saveOrUpdateApprovedContractors(this.state)
                    .then((updatedRecord) => {
                        if (this.state.selectedFiles.length > 0) {
                            uploadMultipleFiles("/approved-contractors/fileUpload", updatedRecord.id, this.state.selectedFiles, () => {
                                NotificationManager.success(t('app.notifications.success'), t('messages.approvedContractorUpdated'), 5000);
                                this.reset();
                            });
                        } else {
                            NotificationManager.success(t('app.notifications.success'), t('messages.approvedContractorUpdated'), 5000);
                            this.reset();
                        }
                    }).catch(error => {
                    console.log("error");
                    console.log(error);
                    NotificationManager.error(t('app.notifications.error'), t('messages.genericError'), 5000);
                });
            })
    }

    onDateChange(date, fieldName) {
        this.setState({
            ...this.state, [fieldName]: moment(date, "DD/MM/YYYY"),
        });
    }

    handleTextChange({ target }) {
        this.setState({
            ...this.state, [target.name]: target.value
        });
    }

    onSignatureEnd(value) {
        this.setState({
            signature: value
        });
    }

    render() {
        let { state } = this;
        let { classes } = this.props;
        if (state.isLoading) {
            return <Spinner/>;
        }
        const isRevision = (state.latestRevision.id !== null);
        const fileNames = this.state.selectedFiles.map((file) => (
            <li key={file.name}>
                {file.name}
            </li>
        ));
        let isDemo = this.props.currentUser && this.props.currentUser.isDemo;
        let isAuditor = CommonUtils.isAuditor(this.props.currentUser);
        let isViewer = CommonUtils.isViewer(this.props.currentUser);
        return <div>
            <Card className={classes.card}>
                {(!state.isEditing ?
                        <CardHeader
                            action={
                                <BlueButton
                                     variant="contained"
                                     color="secondary"
                                     startIcon={<AddCircleOutlineTwoTone/>}
                                     onClick={this.showModal}
                                     size="small"
                                     style={{marginRight: '10px'}}
                                     disabled={isAuditor || isViewer}
                                 >
                                    { t('common.add') }
                                 </BlueButton>
                            }
                            title={
                                <span style={{color: "darkblue"}}>
                                        <p><b>{isRevision && (t('context.common.revision') + ' ' + state.latestRevision.number + ': ' + state.latestRevision.author)}</b></p>
                                        <p><b>{ t('context.common.approvedFor') }: {state.latestRevision.approvedBy} {t('context.common.on')} {moment(state.latestRevision.date).format('DD/MM/YYYY')}</b></p>
                                    </span>
                            }
                        />
                        :
                        <CardHeader
                            style={{ paddingBottom: "0px", paddingLeft: "46px" }}
                            title={
                                <span style={{color: "darkblue"}}>
                                    <p><b>{state.header}</b></p>
                                </span>
                            }
                        />
                )}
                <CardContent>
                    {(!state.isEditing ?
                            <div>
                                <Typography component="h2" variant="h5">
                                    <div style={{float: 'left'}}>{ t('operation.approvedContractors.title') }</div>
                                </Typography>
                                {!isDemo && !isViewer && <GreenButton startIcon={<SystemUpdateAltTwoTone/>} onClick={() => exportReport('/approved-contractors/export')} style={{ float: 'right', marginRight: "160px" }}>{ t('common.export') }</GreenButton>}
                                <TableComponent
                                    tableKey="approvedContractorsTable"
                                    data={state.approvedContractors}
                                    columns={columns}
                                    handleSubmit={this.handleSubmit}
                                    handleAddRow={this.handleAddRow}
                                    handleRowDel={this.onDelete}
                                    handleRowEdit={this.onEdit}
                                    allowAdd={isRevision && !isAuditor && !isViewer ? 'show' : 'disable'}
                                    pagination={true}
                                    allowUpdateDelete={(isAuditor || isViewer) ? 'no' : 'yes'}
                                />
                            </div>
                            :
                            <div style={{ paddingLeft: "30px", paddingRight: "30px",  paddingBottom: "30px"}}>
                                <div style={{ paddingTop: "40px"}}>
                                    <InputLabel>{ t('operation.approvedContractors.nameOfSubcontractor') }</InputLabel>
                                    <TextField
                                        id="name"
                                        name="name"
                                        value={state.name}
                                        onChange={this.handleTextChange}
                                        style={{ width: "600px"}}
                                    />
                                </div>
                                <div style={{ paddingTop: "40px" }}>
                                    <InputLabel>{ t('operation.approvedContractors.assessedDate') }</InputLabel>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            autoOk
                                            variant="inline"
                                            format="DD/MM/YYYY"
                                            margin="normal"
                                            id="assessedDate"
                                            name="assessedDate"
                                            value={state.assessedDate}
                                            onChange={ (event) => this.onDateChange(event, 'assessedDate') }
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: "300px"}}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div style={{ paddingTop: "40px"}}>
                                    <InputLabel>{ t('operation.approvedContractors.assessorName') }</InputLabel>
                                    <TextField
                                        id="assessor"
                                        name="assessor"
                                        value={state.assessor}
                                        onChange={this.handleTextChange}
                                        style={{ width: "600px"}}
                                    />
                                </div>
                                <div style={{ paddingTop: "40px"}}>
                                    <InputLabel>{ t('operation.approvedContractors.copyOfAgreement') }</InputLabel>
                                    <TextField
                                        id="copyOfAgreement"
                                        name="copyOfAgreement"
                                        value={state.copyOfAgreement}
                                        onChange={this.handleTextChange}
                                        style={{ width: "600px"}}
                                    />
                                </div>
                                <div style={{ paddingTop: "40px" }}>
                                    <InputLabel>{ t('operation.approvedContractors.agreementExpiryDate') }</InputLabel>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            autoOk
                                            variant="inline"
                                            format="DD/MM/YYYY"
                                            margin="normal"
                                            id="agreementExpiryDate"
                                            name="agreementExpiryDate"
                                            value={state.agreementExpiryDate}
                                            onChange={ (event) => this.onDateChange(event, 'agreementExpiryDate') }
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: "300px"}}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div style={{ paddingTop: "40px"}}>
                                    <InputLabel>{ t('operation.approvedContractors.copiesOfInsurance') }</InputLabel>
                                    <TextField
                                        id="copiesOfInsurance"
                                        name="copiesOfInsurance"
                                        value={state.copiesOfInsurance}
                                        onChange={this.handleTextChange}
                                        style={{ width: "600px"}}
                                    />
                                </div>
                                {
                                    (state.files && state.files.length > 0) &&
                                    <div style={{ width: "800px", paddingTop: "30px" }}>
                                        <Table>
                                            <TableHead>
                                                <tr style={{ float: "left" }}>
                                                    <th colSpan={3} style={{ textAlign: "center" }}>{ t('operation.approvedContractors.uploadHeading') }</th>
                                                </tr>
                                            </TableHead>
                                            <TableBody>
                                                {/* files list */}
                                                {state.files.map((file) => (
                                                    <tr key={file.id}>
                                                        <td>{file.name}</td>
                                                        <td><GreyButton onClick={() => ApiUtils.downloadFile(file.id)}>{ t('common.download') }</GreyButton></td>
                                                        <td><RedButton onClick={() => this.deleteFileFromRecord(file.id)}>{ t('common.remove') }</RedButton></td>
                                                    </tr>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </div>
                                }
                                <div style={{ width: "800px", minHeight: "100px", paddingTop: "30px"}}>
                                    <Dropzone onDrop={(files) => this.onDrop(files)}>
                                        {({getRootProps, getInputProps}) => (
                                            <span>
                                                <div {...getRootProps()} style={{ verticalAlign: "middle", textAlign: "center", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell", height: "100px", width: "800px"}}>
                                                    <input
                                                        {...getInputProps()}
                                                    />
                                                    <label style={{ /* backgroundColor: '#007bff', color: '#fff',*/ cursor: 'pointer', padding: 15, borderRadius: 3 }}>
                                                        { t('operation.approvedContractors.dragDropPrompt') }
                                                    </label>
                                                </div>
                                                {(fileNames.length > 0) &&
                                                <aside>
                                                    <h4>{ t('operation.approvedContractors.selectedFilesHeading') }</h4>
                                                    <ul>{ fileNames }</ul>
                                                </aside>
                                                }
                                            </span>
                                        )}
                                    </Dropzone>
                                </div>
                                <div style={{ paddingTop: "40px" }}>
                                    <InputLabel>{ t('operation.approvedContractors.insuranceExpiryDate') }</InputLabel>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            autoOk
                                            variant="inline"
                                            format="DD/MM/YYYY"
                                            margin="normal"
                                            id="insuranceExpiryDate"
                                            name="insuranceExpiryDate"
                                            value={state.insuranceExpiryDate}
                                            onChange={ (event) => this.onDateChange(event, 'insuranceExpiryDate') }
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: "300px"}}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div style={{ paddingTop: "40px"}}>
                                    <InputLabel>{ t('operation.approvedContractors.safeWorkMethodCopies') }</InputLabel>
                                    <TextField
                                        id="safeWorkMethod"
                                        name="safeWorkMethod"
                                        value={state.safeWorkMethod}
                                        onChange={this.handleTextChange}
                                        style={{ width: "600px"}}
                                    />
                                </div>
                                <div style={{ paddingTop: "40px" }}>
                                    <InputLabel>{ t('operation.approvedContractors.authorisedDate') }</InputLabel>
                                    <MuiPickersUtilsProvider utils={MomentUtils}>
                                        <KeyboardDatePicker
                                            disableToolbar
                                            autoOk
                                            variant="inline"
                                            format="DD/MM/YYYY"
                                            margin="normal"
                                            id="authorisedDate"
                                            name="authorisedDate"
                                            value={state.authorisedDate}
                                            onChange={ (event) => this.onDateChange(event, 'authorisedDate') }
                                            KeyboardButtonProps={{
                                                'aria-label': 'change date',
                                            }}
                                            style={{ width: "300px"}}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                                <div style={{ paddingTop: "40px"}}>
                                    <InputLabel>{ t('operation.approvedContractors.authorisingPerson') }</InputLabel>
                                    <TextField
                                        id="authorisingPerson"
                                        name="authorisingPerson"
                                        value={state.authorisingPerson}
                                        onChange={this.handleTextChange}
                                        style={{ width: "600px"}}
                                    />
                                </div>
                                <div style={{ width: "400px", height: "360px", paddingTop: "30px" }}>
                                    <label>
                                        { t('operation.approvedContractors.labelSignPrompt') }
                                    </label>
                                    <div style={{ clear: "both", borderStyle: "ridge", borderWidth: "1px", padding: "0px", display: "table-cell" }}>
                                        <SignaturePad
                                            canvasProps={{ width: "400px", height: "300px" }}
                                            onEnd={() => { console.log('onEnd called'); this.onSignatureEnd(this.sigPad.toDataURL('image/png')); }}
                                            ref={(ref) => {
                                                this.sigPad = ref;
                                                if (state.signature && this.sigPad) {
                                                    this.sigPad.fromDataURL(state.signature, { width: 400, height: 300})
                                                }
                                            }}
                                        />
                                        <GreyButton onClick={this.clear}>
                                            { t('common.cancel') }
                                        </GreyButton>
                                    </div>
                                </div>
                                <div style={{ width: "800px", clear: "both", paddingTop: "30px" }}>
                                    <OrangeButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleTwoTone />}
                                        size="small"
                                        onClick={this.onCancel}
                                        style={{ marginTop: '20px', marginBottom: '20px', marginRight: '20px' , float: "left" }}
                                    >
                                        { t('context.common.cancel') }
                                     </OrangeButton>
                                     <GreenButton
                                        variant="contained"
                                        color="secondary"
                                        startIcon={<AddCircleTwoTone />}
                                        size="small"
                                        onClick={this.onSave}
                                        style={{ marginTop: '20px', marginBottom: '20px', float: "left" }}
                                    >
                                        { t('context.common.save') }
                                    </GreenButton>
                                </div>
                            </div>
                    )}
                </CardContent>
            </Card>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={state.show}
                onClose={() => this.closeModal(null)}
            >
                <CommonRevisionModal latestRevisionDto={state.latestRevision} addRevision={this.addRevision}/>
            </Modal>
            <NotificationContainer/>
        </div>;
    }
}

export default withStyles(classes)(ApprovedContractor);
